import api from '../axios.config';
import { API_ENDPOINTS, createEndpoint } from './endpoints';

export const BillingService = {
  getBillingList: async ({
    page,
    pageSize,
    search,
    status,
    sortBy,
    sortOrder,
  }) => {
    const endpoint = createEndpoint(API_ENDPOINTS.BILLING.LISTPURCHASEPRDERS, {
      pageNo: page,
      pageSize,
      search,
      status,
      sortBy,
      sortOrder,
    });
    const response = await api.get(endpoint);
    return response;
  },

  getBillingInfo: async (id) => {
    const endpoint = createEndpoint(API_ENDPOINTS.BILLING.BILLINGINFO, {
      id,
    });

    const response = await api.get(endpoint);
    return response;
  },
  verifyPurchaseOrder: async (id) => {
    const endpoint = createEndpoint(API_ENDPOINTS.BILLING.VERIFYPURCHASEORDER, {
      id,
    });
    const response = await api.put(endpoint);
    return response;
  },
  getMilestoneList: async ({ page, pageSize }) => {
    const endpoint = createEndpoint(API_ENDPOINTS.BILLING.LISTMILESTONES, {
      pageNo: page,
      pageSize,
    });

    const response = await api.get(endpoint);
    return response;
  },
  verifyMilestone: async (id) => {
    const endpoint = createEndpoint(API_ENDPOINTS.BILLING.VERIFYMILESTONE, {
      id,
    });
    const response = await api.post(endpoint);
    return response;
  },
  getInvoiceList: async ({
    page,
    pageSize,
    search,
    status,
    sortBy,
    sortOrder,
  }) => {
    const endpoint = createEndpoint(API_ENDPOINTS.BILLING.LISTINVOICE, {
      pageNo: page,
      pageSize,
      search,
      status,
      sortBy,
      sortOrder,
    });

    const response = await api.get(endpoint);
    return response;
  },
  getInvoiceInfo: async (id) => {
    const endpoint = createEndpoint(API_ENDPOINTS.BILLING.INVOICEINFO, {
      id,
    });
    const response = await api.get(endpoint);
    return response;
  },
  verifyInvoice: async (id) => {
    const endpoint = createEndpoint(API_ENDPOINTS.BILLING.VERIFYINVOICE, {
      id,
    });
    const response = await api.put(endpoint);
    return response;
  },
  getProformaInvoiceList: async ({
    page,
    pageSize,
    search,
    status,
    sortBy,
    sortOrder,
  }) => {
    const endpoint = createEndpoint(API_ENDPOINTS.BILLING.LISTPROFORMAINVOICE, {
      pageNo: page,
      pageSize,
      search,
      status,
      sortBy,
      sortOrder,
    });
    const response = await api.get(endpoint);
    return response;
  },
  getProformaInvoiceInfo: async (id) => {
    const endpoint = createEndpoint(API_ENDPOINTS.BILLING.PROFORMAINVOICEINFO, {
      id,
    });
    const response = await api.get(endpoint);
    return response;
  },
  verifyProformaInvoice: async (id) => {
    const endpoint = createEndpoint(
      API_ENDPOINTS.BILLING.VERIFYPROFORMAINVOICE,
      {
        id,
      }
    );
    const response = await api.put(endpoint);
    return response;
  },
  confirmProformaInvoicePayment: async (id, data) => {
    const endpoint = createEndpoint(
      API_ENDPOINTS.BILLING.CONFIRMPROFORMAINVOICEPAYMENT,
      {
        id,
      }
    );
    const response = await api.post(endpoint, data);
    return response;
  },
  confirmInvoicePayment: async (id, data) => {
    const endpoint = createEndpoint(
      API_ENDPOINTS.BILLING.CONFIRMINVOICEPAYMENT,
      {
        id,
      }
    );
    const response = await api.post(endpoint, data);
    return response;
  },
  getCreditNoteInfo: async (id) => {
    const endpoint = createEndpoint(API_ENDPOINTS.BILLING.CREDITNOTEINFO, {
      id,
    });
    const response = await api.get(endpoint);
    return response;
  },
  getCreditNoteList: async ({ page, pageSize, status }) => {
    const endpoint = createEndpoint(API_ENDPOINTS.BILLING.CREDITNOTELIST, {
      pageNo: page,
      pageSize,
      status,
    });
    const response = await api.get(endpoint);
    return response;
  },
  approveCreditNote: async (id, data) => {
    const endpoint = createEndpoint(API_ENDPOINTS.BILLING.APPROVECREDITNOTE, {
      id,
    });
    const response = await api.put(endpoint, data);
    return response;
  },
  getInvoiceDisputes: async (id) => {
    const endpoint = createEndpoint(API_ENDPOINTS.BILLING.INVOICEDISPUTES, {
      id,
    });
    const response = await api.get(endpoint);
    return response;
  },
  updateInvoiceDispute: async (id, data) => {
    const endpoint = createEndpoint(API_ENDPOINTS.BILLING.INVOICEDISPUTES, {
      id,
    });
    const response = await api.put(endpoint, data);
    return response;
  },
  // One type per call, matching whichever list page is asking — a page
  // only ever needs its own summary (work_order for ListBilling, invoice
  // for ListInvoices, proforma_invoice for ListProformaInvoices), never
  // more than one at once.
  getBillingSummary: async (type) => {
    const response = await api.get(
      `${API_ENDPOINTS.BILLING.BILLING_SUMMARY}?types=${encodeURIComponent(type)}`
    );
    return response;
  },
};
